import { ThemeEvents } from '@theme/events';

class ProductMediaGallery extends HTMLElement {
  connectedCallback() {
    document.addEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  updateMediaGallery = (event) => {
    const newMediaGallery = event.detail?.data?.html?.querySelector('product-media-gallery slider-component');
    const currentMediaGallery = this.querySelector('slider-component');

    if (newMediaGallery && currentMediaGallery && currentMediaGallery.innerHTML !== newMediaGallery.innerHTML) {
      currentMediaGallery.replaceWith(newMediaGallery);
    }

    // Aller à l'image de la variante après que tout soit en place
    requestAnimationFrame(() => {
      setTimeout(() => this.goToVariantImage(event), 50);
    });
  };

  goToVariantImage = (event) => {
    const variant = event?.detail?.resource;
    const featuredMedia = variant?.featured_media;

    if (!featuredMedia) return;

    // ⚠️ 15/09/2026 — on cherche la diapositive par son identifiant d'image.
    //    La position renvoyée par Shopify est celle de product.media ; l'ordre
    //    affiché peut différer (images de variantes masquées, tri du bloc).
    //    S'y fier laissait la photo du coloris précédent à l'écran.
    const slides = Array.from(this.querySelectorAll('.splide__slide[data-media-id]'));
    const found = slides.findIndex((s) => s.dataset.mediaId == featuredMedia.id);
    const targetIndex = found >= 0 ? found : (featuredMedia.position || 1) - 1;

    // L'instance Splide est sur slider-component.slider (custom property du thème Fullstack)
    const sliderComponent = this.querySelector('slider-component');
    const splideInstance = sliderComponent?.slider;

    if (splideInstance && typeof splideInstance.go === 'function') {
      splideInstance.go(targetIndex);
    }
  };
}

if (!customElements.get('product-media-gallery')) {
  customElements.define('product-media-gallery', ProductMediaGallery);
}